import { bool, node, string } from 'prop-types';
import React, { useRef } from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { associatedOpportunityShape } from '../../prop-types';
import { withFullName } from '../../users/utils';

function OpportunityLink({ children, model, showIcon, className, ...rest }) {
  const {
    id,
    name,
    businessModel,
    billingType,
    netClientBudget,
    expectedRevenue,
    pc1,
    collaborators,
  } = model;
  const linkRef = useRef(null);

  return (
    <>
      <span ref={linkRef}>
        <IconLink
          showIcon={showIcon}
          to={`/opportunities/${id}/show`}
          {...rest}
        >
          {children || name}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        className={className}
        title={name}
        fields={{
          'Business Model': businessModel,
          'Billing Type': billingType,
          'Net Client Budget': (
            <CurrencyFormat
              name="netClientBudget"
              value={netClientBudget || 0}
              text
            />
          ),
          'Expected Revenue': (
            <CurrencyFormat
              name="expectedRevenue"
              value={expectedRevenue || 0}
              text
            />
          ),
          PC1: withFullName(pc1).fullName || '-',
          Collaborators: (collaborators || [])
            .map(user => withFullName(user).fullName)
            .join(', '),
        }}
      />
    </>
  );
}

OpportunityLink.propTypes = {
  children: node,
  className: string,
  model: associatedOpportunityShape.isRequired,
  showIcon: bool,
};

OpportunityLink.defaultProps = {
  children: null,
  className: '',
  showIcon: false,
};

export default OpportunityLink;
